export default "__VITE_ASSET__DFlMjmFF__"